import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles/index.css';

// Prevent FOIT (Flash of Invisible Text)
document.documentElement.classList.add('loading');

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }}>
    <App />
  </BrowserRouter>
);

// Remove loading class once fonts are loaded
document.fonts.ready.then(() => {
  document.documentElement.classList.remove('loading');
});